import axios from "axios";
export default class EmailService {
    sendEmail(orderId, emailType, emailHtmlContent, attachments) {
        const emailDto = {
            htmlContent: emailHtmlContent,
            orderDocumentNames: attachments
        };
        return axios.post("/email/" + emailType, emailDto, {
            params: {
                orderId: orderId,
            },
            withCredentials: true
        });
    }
    getEmailTemplate(emailType, orderId) {
        return axios.get("/email/" + emailType, {
            params: {
                orderId
            },
            withCredentials: true
        });
    }
}
